<div class="container px-0 justify-content-center arabic-dir">
  <div class="shadow p-1 p-lg-3 mb-5 bg-white mx-0">
    <div class="row mx-0 pt-4">
      <div class="col-md-2 mx-0 px-2">
        <img
          src="../../assets/food.jpg"
          alt=""
          height="100%"
          width="100%"
          class="border p-1"
        />
      </div>
      <div class="col-md-7 text-left float-left col-8 pt-2">
        <h5 *ngIf="appService.lang == 'en'" class="mt-1 t-media-14">
          Lorem, ipsum.
        </h5>
        <h5 *ngIf="appService.lang == 'ar'" class="mt-1 t-media-14">
          نص عشوائي
        </h5>

        <p *ngIf="appService.lang == 'en'" class="text-muted t-media-14 mb-0">
          Lorem ipsum dolor sit amet consectetur.
        </p>
        <p *ngIf="appService.lang == 'ar'" class="text-muted t-media-14 mb-0">
          تم توليد هذا النص من مولد النص
        </p>
        <br />
        <small>Min. order: JOD 0.00</small>
      </div>
      <div class="col-md-3 col-4 pt-2 text-right float-right pt-3">
        <h6 class="text-success t-media-14 mb-1">
          <span *ngIf="appService.lang == 'en'">open </span>
          <span *ngIf="appService.lang == 'ar'"> مفتوح </span>
        </h6>
        <p class="text-muted t-media-14 mb-0">
          <span *ngIf="appService.lang == 'en'">Very Good</span
          ><span *ngIf="appService.lang == 'ar'">جيد جدا</span>
        </p>

        <img src="../../assets/cash-icon.svg" alt="" height="16" width="auto" />
      </div>
    </div>
    <div class="bg-secondary py-2 my-3 px-2 mx-2 row arabic-dir">
      <i class="fa fa-info-circle mx-1 my-auto" aria-hidden="true"></i>
      <small class=""> {{ "BAZZAR.PAYMENT_ONLY_CASH" | translate }}</small>
    </div>

    <div class="topnav col-md-9 mx-0 px-0 pt-3 shop-nav">
      <a
        class="text-center pb-2"
        (click)="showMenu()"
        [ngClass]="{ active: showMenuDiv === true }"
      >
        <img
          src="../../assets/menu-ico.svg"
          alt=""
          height="20"
          width="20"
          class="d-md-inline-block d-none mb-0"
        />
        {{ "BAZZAR.MENU" | translate }}</a
      >
      <a
        class="pb-2 text-center"
        (click)="showReviews()"
        [ngClass]="{ active: showReviewsDiv === true }"
      >
        <img
          src="../../assets/icon_reviews.svg"
          alt=""
          class="d-md-inline-block d-none mb-0"
          height="20"
          width="20"
        />
        {{ "BAZZAR.REVIEWS" | translate }}
      </a>
      <a
        class="pb-2 text-center"
        (click)="showInfo()"
        [ngClass]="{ active: showInfoDiv === true }"
      >
        <img
          src="../../assets/icon_info_menu.svg"
          alt=""
          class="d-md-inline-block d-none"
          height="20"
          width="20"
        />
        <span class="mx-2">{{ "BAZZAR.INFO" | translate }}</span>
      </a>
    </div>
    <hr class="mt-0 mx-2 mb-4" />
    <div class="row my-3 mx-0 px-0">
      <div *ngIf="showMenuDiv == true" class="row mx-0 col-lg-8 px-1">
        <div
          class="col-md-3 border sticky-top d-none d-lg-block mx-0 px-0 nav_of_categories"
          style="height: fit-content"
        >
          <p class="text-center mt-3 font-weight-bold">
            {{ "BAZZAR.CATEGORIES" | translate }}
          </p>
          <hr class="mb-1" />
          <div
            class="nav flex-column nav-pills"
            id="v-pills-tab"
            role="tablist"
            aria-orientation="vertical"
          >
            <a
              class="nav-link py-2 text-left active"
              id="v-pills-home-tab"
              data-toggle="pill"
              role="tab"
              aria-selected="true"
            >
              <span *ngIf="appService.lang == 'en'">Lorem, ipsum.</span>
              <span *ngIf="appService.lang == 'ar'">نص عشوائي </span>
            </a>
          </div>
          <div
            class="nav flex-column nav-pills"
            id="v-pills-tab"
            role="tablist"
            aria-orientation="vertical"
          >
            <a
              class="nav-link py-2 text-left"
              id="v-pills-home-tab"
              data-toggle="pill"
              role="tab"
              aria-selected="true"
            >
              <span *ngIf="appService.lang == 'en'">Lorem, ipsum.</span>
              <span *ngIf="appService.lang == 'ar'">نص عشوائي </span>
            </a>
          </div>
        </div>

        <div class="col-lg-9 mx-0 px-lg-3 px-2">
          <div class="px-0 mb-3 mb-lg-0">
            <input
              type="text"
              class="form-control"
              placeholder="{{ 'BAZZAR.SEARCH' | translate }}"
            />
          </div>
          <div>
            <div class="tab-pane show" role="tabpanel">
              <div class="row py-2 bg-light mx-0 mt-2">
                <div class="text-left col-10 t-media-14">Lorem, ipsum.</div>
                <div class="text-right col-2" *ngIf="showitems == true">
                  <i
                    class="fa fa-chevron-up text-left-ar"
                    (click)="unShowItems()"
                  ></i>
                </div>
                <div
                  class="text-right col-2 text-left-ar"
                  *ngIf="showitems === false"
                >
                  <i (click)="showItems()" class="fa fa-chevron-down"></i>
                </div>
              </div>

              <div *ngIf="showitems === true" class="productAnimation">
                <div class="row mx-0 mt-3 px-0">
                  <div class="pr-1 pl-0 mx-0 col-lg-2 col-2">
                    <img
                      src="../../assets/food.jpg"
                      alt=""
                      height="70"
                      width="100%"
                      class="p-1 border"
                    />
                  </div>
                  <div class="text-left col-lg-7 col-7 mx-0 px-1">
                    <span
                      *ngIf="appService.lang == 'en'"
                      class="font-weight-600 small"
                      >Lorem, ipsum.</span
                    >
                    <span
                      *ngIf="appService.lang == 'ar'"
                      class="font-weight-600 small"
                      >نص عشوائي</span
                    >
                    <br />
                    <small
                      *ngIf="appService.lang == 'en'"
                      class="t-12 text-muted"
                      >Lorem ipsum dolor sit.
                    </small>
                    <small
                      *ngIf="appService.lang == 'ar'"
                      class="t-12 text-muted"
                      >تم توليد هذا النص من مولد النص
                    </small>
                    <br />
                    <small class="t-12 text-muted">
                      {{ "BAZZAR.DELIVERY" | translate }} : Lorem, ipsum dolor.
                    </small>
                  </div>
                  <div class="text-center px-0 float-right col-lg-2 col-1">
                    <small
                      >33.00 <br />
                      {{ "BAZZAR.JD" | translate }}
                      <br />
                    </small>
                  </div>
                  <div class="col-lg-1 col-2 text-right text-left-ar mx-0 px-0">
                    <i
                      class="fa fa-plus-circle text-success fa-20 icon-add mt-1"
                      (click)="openDialogAddProduct()"
                    ></i>
                  </div>
                </div>

                <hr />
                <div class="row mx-0 mt-3 px-0">
                  <div class="pr-1 pl-0 mx-0 col-lg-2 col-2">
                    <img
                      src="../../assets/food.jpg"
                      alt=""
                      height="70"
                      width="100%"
                      class="p-1 border"
                    />
                  </div>
                  <div class="text-left col-lg-7 col-7 mx-0 px-1">
                    <span
                      *ngIf="appService.lang == 'en'"
                      class="font-weight-600 small"
                      >Lorem, ipsum.</span
                    >
                    <span
                      *ngIf="appService.lang == 'ar'"
                      class="font-weight-600 small"
                      >نص عشوائي</span
                    >
                    <br />
                    <small
                      *ngIf="appService.lang == 'en'"
                      class="t-12 text-muted"
                      >Lorem ipsum dolor sit.
                    </small>
                    <small
                      *ngIf="appService.lang == 'ar'"
                      class="t-12 text-muted"
                      >تم توليد هذا النص من مولد النص
                    </small>
                    <br />
                    <small class="t-12 text-muted">
                      {{ "BAZZAR.DELIVERY" | translate }} : Lorem, ipsum dolor.
                    </small>
                  </div>
                  <div class="text-center px-0 float-right col-lg-2 col-1">
                    <small
                      >33.00 <br />
                      {{ "BAZZAR.JD" | translate }}
                      <br />
                    </small>
                  </div>
                  <div class="col-lg-1 col-2 text-right text-left-ar mx-0 px-0">
                    <i
                      class="fa fa-plus-circle text-success fa-20 icon-add mt-1"
                      (click)="openDialogAddProduct()"
                    ></i>
                  </div>
                </div>

                <hr />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div *ngIf="showReviewsDiv == true" class="col-lg-8 px-2 text-left">
        <h5>{{ "BAZZAR.REVIEWS" | translate }} (2)</h5>
        <div class="row bg-light border mx-0 rounded-sm px-2 my-4">
          <div class="col-6 col-md-3 pl-0 text-left">
            <ngb-rating
              [max]="5"
              [(rate)]="currentRate"
              [readonly]="true"
            ></ngb-rating>
          </div>

          <div
            class="col-md-6 small text-muted text-left d-none d-md-block my-auto"
          >
            khaled
          </div>
          <div class="col-md-3 col-6 small my-auto text-right text-muted">
            10/10/2021 - 10 pm
          </div>

          <div
            class="row mx-0 d-block d-md-none my-auto small text-muted text-left"
          >
            khaled
          </div>
          <div class="small font-weight-bold pb-3 pt-2 row mx-0">
            Lorem ipsum dolor sit amet consectetur adipisicing elit. Odit,
            cumque nihil!
          </div>
        </div>
        <div class="row bg-light border mx-0 rounded-sm px-2 my-4">
          <div class="col-6 col-md-3 pl-0 text-left">
            <ngb-rating
              [max]="5"
              [(rate)]="currentRate"
              [readonly]="true"
            ></ngb-rating>
          </div>

          <div
            class="col-md-6 small text-muted text-left d-none d-md-block my-auto"
          >
            khaled
          </div>
          <div class="col-md-3 col-6 small my-auto text-right text-muted">
            10/10/2021 - 10 pm
          </div>

          <div
            class="row mx-0 d-block d-md-none my-auto small text-muted text-left"
          >
            khaled
          </div>
          <div class="small font-weight-bold pb-3 pt-2 row mx-0">
            Lorem ipsum dolor sit amet consectetur adipisicing elit. Odit,
            cumque nihil!
          </div>
        </div>
      </div>
      <div *ngIf="showInfoDiv == true" class="col-lg-8">
        <p class="font-weight-600 h6 mt-4 mb-4 text-left">Shop Name</p>
        <hr />
        <div class="row mx-0">
          <div
            class="col-md-3 text-dark text-left px-0 font-weight-600 font-14px my-auto"
          >
            {{ "BAZZAR.DESCRIPTION" | translate }}
          </div>
          <div class="col-md-9 text-left px-0 font-14px mt-3 mt-md-0">
            <span *ngIf="appService.lang == 'en'"
              >Lorem ipsum dolor sit amet.</span
            ><span *ngIf="appService.lang == 'ar'"
              >وصف المتجر باللغة العربية</span
            >
          </div>
        </div>
        <hr />
        <div class="row mx-0">
          <div
            class="col-md-3 text-dark text-left px-0 font-weight-600 font-14px"
          >
            {{ "BAZZAR.RATING" | translate }}
          </div>
          <div class="col-md-9 text-left px-0 font-14px mt-3 mt-md-0">
            <img src="../../assets/smile.png" alt="" height="20" class="mx-1" />
            <span *ngIf="appService.lang == 'en'">Very Good</span
            ><span *ngIf="appService.lang == 'ar'">جيد جدا</span>
          </div>
        </div>
        <hr />
        <div class="row mx-0 mb-4">
          <div
            class="col-md-3 text-dark text-left px-0 font-weight-600 font-14px"
          >
            {{ "BAZZAR.PAYMENT" | translate }}
          </div>
          <div class="col-md-9 text-left px-0 font-14px mt-3 mt-md-0">
            <img
              src="../../assets/cash-icon.svg"
              alt=""
              height="20"
              class="mx-1"
            />
            {{ "BAZZAR.CASH" | translate }}
          </div>
        </div>
      </div>

      <div class="col-lg-4 mx-0 px-2" *ngIf="showFilledCart === false">
        <div class="card sticky-top p-0 m-0">
          <div class="card-header bg-primary m-0 text-left h5">
            {{ "BAZZAR.YOUR_CART" | translate }}
          </div>
          <div class="card-body text-center bg-light">
            <img
              src="../../assets/empty-cart.svg"
              alt=""
              height="100"
              width="100%"
            />
            <div class="mt-2"></div>
            <small class="font-weight-600">{{
              "BAZZAR.NO_ITEMS" | translate
            }}</small>
          </div>
        </div>
      </div>
      <div class="col-lg-4 mx-0 px-2" *ngIf="showFilledCart === true">
        <div class="card sticky-top p-0 m-0">
          <div class="card-header bg-primary m-0 h5 text-left">
            {{ "BAZZAR.YOUR_CART" | translate }}
          </div>
          <p class="p-2 mb-0" *ngIf="appService.lang == 'en'">Lorem, ipsum.</p>
          <p class="p-2 mb-0 text-right" *ngIf="appService.lang == 'ar'">
            نص عشوائي
          </p>
          <hr class="m-0" />
          <div class="text-left bg-light small row mx-0 p-2">
            <div
              class="border bg-white text-left small my-auto"
              style="height: fit-content"
              dir="ltr"
            >
              <i
                class="fa fa-plus text-primary border-right px-1 py-2"
                (click)="increment()"
              ></i>
              <span class="p-2"> {{ counter }} </span>
              <i
                class="fa fa-minus text-primary border-left py-2 px-1"
                (click)="decrement()"
              ></i>
            </div>
            <div class="col-6 my-auto">
              <span *ngIf="appService.lang === 'en'" class="t-12"
                >Lorem, ipsum dolor.</span
              >
              <span class="t-12" *ngIf="appService.lang === 'ar'"
                >نص عشوائي</span
              >
            </div>
            <div class="col-2 my-auto">
              <span class="font-weight-600 text-muted">22</span>
            </div>
            <div class="col-1 my-auto">
              <small class="font-weight-600 text-muted"
                ><i class="fa fa-minus-circle" (click)="showEmptyCart()"></i
              ></small>
            </div>
          </div>
          <hr class="m-0" />
          <div class="p-3 filled_cart">
            <div class="row">
              <div class="col-6 text-left">
                <small class="text-muted"
                  >{{ "BAZZAR.SUBTOTAL" | translate }}
                </small>
              </div>
              <div class="col-6 text-right">
                <small class="text-muted"
                  >22.00 {{ "BAZZAR.JD" | translate }}</small
                >
              </div>
            </div>

            <div class="row mt-3">
              <div class="col-6 text-left">
                <small class="font-weight-600 text-13px"
                  >{{ "BAZZAR.TOTAL_AMOUNT" | translate }}
                </small>
              </div>
              <div class="col-6 text-right">
                <small class="text-13px font-weight-bold"
                  >33.00 {{ "BAZZAR.JD" | translate }}</small
                >
              </div>
            </div>
            <hr />
            <a class="btn btn-success w-100 text-13px" routerLink="/checkout">
              {{ "BAZZAR.PROCEED_TO_CHECKOUT" | translate }}
            </a>
          </div>
        </div>
      </div>
    </div>
    <!--row closed-->
    <!--card-->
  </div>
</div>
